import React from 'react';
import PropTypes from 'prop-types';

function ProcessingModeWrapper({ children }) {
  return <div className="patent-content__flex-row">{children}</div>;
}

ProcessingModeWrapper.propTypes = {
  children: PropTypes.node,
};

export default ProcessingModeWrapper;
